export default {
    data() {
        return {
            commonErrors: [],
            error: '',
        }
    },
    methods: {
        clearErrors() {
            this.commonErrors = []
            this.error = ''
        },
        processErrors(errors) {
            if (errors.length > 0) {
                for (let error of errors) {
                    if (error.code <= 400) {
                        this.error = error.message
                    } else {
                        this.commonErrors.push(error.message)
                    }
                }
            }
        }
    }
}